import * as echarts from 'echarts'

const homeScatter = (data1, data2, data3, data4, data5) => {
  // 通用格式化函数
  const formatData = (data) => {
    return Array.isArray(data)
      ? data.map(item => {
          const rawDate = new Date(item[0]);
          const dateStr = echarts.format.formatTime('yyyy-MM-dd', rawDate);
          const baseData = [
            rawDate,
            item[1],
            item[2]?.replace('%', ''),
            item[3]
          ];
  
          if (dateStr === '2024-07-08' || dateStr === '2024-11-04') {
            // ±30 像素内随机偏移
            const offsetX = Math.floor(Math.random() * 30 - 30);
            const offsetY = Math.floor(Math.random() * 30 - 30);
            return {
              value: baseData,
              symbolOffset: [offsetX, offsetY]
            };
          }
  
          return baseData;
        })
      : [];
  };

  const formattedData1 = formatData(data1);
  const formattedData2 = formatData(data2);
  const formattedData3 = formatData(data3);
  const formattedData4 = formatData(data4);
  const formattedData5 = formatData(data5);

  const itemStyle = {
    opacity: 0.8,
    shadowBlur: 10,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    shadowColor: 'rgba(0,0,0,0.3)',
  };

  const seriesList = [];

  if (formattedData1.length) {
    seriesList.push({
      name: 'Diploid',
      type: 'scatter',
      
      itemStyle,
      data: formattedData1
    });
  }
  if (formattedData2.length) {
    seriesList.push({
      name: 'Triploid',
      type: 'scatter',
      itemStyle,
      data: formattedData2
    });
  }
  if (formattedData3.length) {
    seriesList.push({
      name: 'Tetraploidy',
      type: 'scatter',
      itemStyle,
      data: formattedData3
    });
  }
  if (formattedData4.length) {
    seriesList.push({
      name: 'Hexaploid',
      type: 'scatter',
      itemStyle,
      data: formattedData4
    });
  }
  if (formattedData5.length) {
    seriesList.push({
      name: 'Octoploid',
      type: 'scatter',
      itemStyle,
      data: formattedData5
    });
  }

  const defaultConfig = {
    color: ['#28a745', '#409eff', '#f56c6c', '#dfb154', '#706caa'],
    legend: {
      top: 10,
      data: seriesList.map(s => s.name), // 动态 legend
      textStyle: {
        fontSize: 16
      }
    },
    grid: {
      left: '10%',
      right: 150,
      top: '18%',
      bottom: '10%'
    },
    tooltip: {
      backgroundColor: 'rgba(255,255,255,0.7)',
      formatter: function (param) {
        var value = param.value;
        var formattedName = value[3]?.replace(/_/g, ' ') || '';
        return '<i><div style="border-bottom: 1px solid rgba(255,255,255,.3); font-size: 18px;padding-bottom: 3px;margin-bottom: 3px">' +
          ' ' + formattedName +
          '</div></i>' +
          "Genome size" + ': ' + value[1] + " Mb" + '<br>' +
          "T2T/all rate" + ': ' + value[2] + "%" + '<br>' +
          "Release date: " + echarts.format.formatTime('yyyy-MM-dd', value[0]) + '<br>';
      }
    },
    xAxis: {
      type: 'time',
      name: 'Release date',
      nameGap: 16,
      nameTextStyle: {
        fontSize: 20
      },
      splitLine: {
        show: true
      },
      axisLabel: {
        formatter: function (value) {
          return echarts.format.formatTime('yyyy-MM-dd', value);
        }
      }
    },
    yAxis: {
      type: 'log', // <-- 改为对数坐标轴
      logBase: 3, // 默认就是10，可以调整为2、e等
      name: 'Genome size',
      nameLocation: 'center',
      nameGap: 60,
      nameTextStyle: {
        fontSize: 20
      },
      splitLine: {
        show: false
      },
      axisLabel: {
        formatter: function (val) {
          // 格式化为常见的表达，例如 1024 -> 1G
          if (val >= 1000) {
            return (val / 1024).toFixed(1) + 'G';
          }
          return val + 'M';
        }
      }

    },
    dataZoom: [
      {
        type: 'inside'
      },
      {
        type: "slider",
        fillerColor: "rgba(46, 50, 56, 0.05)",
        borderColor: "rgba(46, 50, 56, 0)",
        textStyle: {
          color: "rgba(28, 31, 35, 0.6)",
          fontFamily: "Inter"
        },
        dataBackground: {
          areaStyle: {
            color: "rgba(46, 50, 56, 0.09)"
          }
        },
        handleIcon: "path://M15,30C15,21.71270751953125,21.71270751953125,15,30,15C38.28729248046875,15,45,21.71270751953125,45,30C45,38.28729248046875,38.28729248046875,45,30,45C21.71270751953125,45,15,38.28729248046875,15,30Z",
        handleStyle: {
          color: "#fff",
          shadowColor: "rgba(0, 0, 0, 0.1)",
          shadowBlur: "6px"
        }
      }
    ],
    visualMap: [
      {
        left: 'right',
        top: '10%',
        dimension: 2,
        min: 0,
        max: 100,
        itemWidth: 30,
        itemHeight: 120,
        calculable: true,
        precision: 0.1,
        text: ['% T2T rate'],
        inRange: {
          symbolSize: [0, 30]
        },
        outOfRange: {
          symbolSize: [30, 50],
          color: ['rgba(255,255,255,0.4)']
        },
        controller: {
          inRange: {
            color: ['#28a745']
          },
          outOfRange: {
            color: ['#999']
          }
        }
      }
    ],
    series: seriesList
  };

  const opt = Object.assign({}, defaultConfig);

  return opt;
};

export default homeScatter;
